import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7045f6ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "form fv-plugins-bootstrap5 fv-plugins-framework" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "p-9" }
const _hoisted_9 = {
  key: 0,
  class: "row mb-9"
}
const _hoisted_10 = { class: "col-6 d-flex flex-column" }
const _hoisted_11 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-semobold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "From Currency")
], -1))
const _hoisted_13 = { value: "" }
const _hoisted_14 = ["label", "value"]
const _hoisted_15 = { class: "col-6 d-flex flex-column" }
const _hoisted_16 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-semobold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "To Currency")
], -1))
const _hoisted_18 = { value: "" }
const _hoisted_19 = ["label", "value"]
const _hoisted_20 = {
  key: 1,
  class: "row mb-9"
}
const _hoisted_21 = { class: "col-6 d-flex flex-column" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "required mb-3"
}, "From Currency", -1))
const _hoisted_23 = { class: "col-6 d-flex flex-column" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "required mb-3"
}, "To Currency", -1))
const _hoisted_25 = { class: "row mb-9" }
const _hoisted_26 = { class: "col-6 d-flex flex-column" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "required mb-3"
}, "Name", -1))
const _hoisted_28 = { class: "col-6 d-flex flex-column" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "required mb-3"
}, "Adjust Rate", -1))
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-6 d-flex flex-column" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "required mb-3"
}, "Buying Rate", -1))
const _hoisted_33 = { class: "col-6 d-flex flex-column" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "required mb-3"
}, "Selling Rate", -1))
const _hoisted_35 = { key: 2 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-2 mt-9" }, "History", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_38 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests",
  style: {"width":"100%"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Buy"),
    /*#__PURE__*/_createElementVNode("th", null, "Sell"),
    /*#__PURE__*/_createElementVNode("th", null, "Adjust"),
    /*#__PURE__*/_createElementVNode("th", null, "Who"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Time")
  ])
], -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { colspan: "12" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { colspan: "12" }
const _hoisted_44 = {
  key: 2,
  name: "table-delete-fade",
  class: "table-delete-fade-container text-gray-600 fw-semibold"
}
const _hoisted_45 = {
  key: 3,
  class: "mt-15 fs-5 text-center text-gray-600"
}
const _hoisted_46 = { class: "modal-footer" }
const _hoisted_47 = { class: "d-flex flex-stack" }
const _hoisted_48 = { class: "me-2" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1))
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }

import { ref, nextTick } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import RebateService from "../services/RebateService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { showModal, hideModal } from "@/core/helpers/dom";
import { ConfigCurrencySelections } from "@/core/types/CurrencyTypes";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeRateModal',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(true);
const isUpdate = ref(true);
const updateForm = ref<any>({});
const dataHistory = ref<any>([]);
const currencySelections = ref(Array<any>());
const exchangeRateModalRef = ref<null | HTMLElement>(null);



const reset = () => {
  isLoading.value = true;
};

const show = async (_isUpdate: boolean, _item?: any) => {
  reset();
  await nextTick();
  showModal(exchangeRateModalRef.value);

  isLoading.value = true;
  isUpdate.value = _isUpdate;
  updateForm.value = {};

  if (_isUpdate) {
    updateForm.value = JSON.parse(JSON.stringify(_item));

    try {
      dataHistory.value = await RebateService.getExchangeRateHistory(_item?.id);
      isLoading.value = false;
    } catch (error) {
      // console.log(error);
    }
  } else {
    isLoading.value = false;
  }
};

const updateExRate = async () => {
  isLoading.value = true;

  try {
    if (isUpdate.value) {
      await RebateService.putExchangeRate(updateForm.value.id, {
        id: updateForm.value.id,
        name: updateForm.value.name,
        buyingRate: updateForm.value.buyingRate,
        sellingRate: updateForm.value.sellingRate,
        adjustRate: updateForm.value.adjustRate,
      });
    } else {
      await RebateService.postExchangeRate({
        fromCurrencyId: updateForm.value.fromCurrencyId,
        toCurrencyId: updateForm.value.toCurrencyId,
        name: updateForm.value.name,
        buyingRate: updateForm.value.buyingRate,
        sellingRate: updateForm.value.sellingRate,
        adjustRate: updateForm.value.adjustRate,
      });
    }

    hide();
    emits("refresh");
  } catch (error) {
    MsgPrompt.error(error).then(() => {
      isLoading.value = false;
    });
  }
};

const hide = () => {
  hideModal(exchangeRateModalRef.value);
};

__expose({
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade exchangeModalHistoryTable",
    id: "kt_modal_create_deposit",
    tabindex: "-1",
    "aria-hidden": "true",
    ref_key: "exchangeRateModalRef",
    ref: exchangeRateModalRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, [
              (isUpdate.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Update Exchange Rate"))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "Create Exchange Rate"))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (!isUpdate.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_unref(Field), {
                        name: "currencyId",
                        class: "form-select form-select-solid",
                        as: "select",
                        modelValue: updateForm.value.fromCurrencyId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updateForm.value.fromCurrencyId) = $event)),
                        modelModifiers: { number: true }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t("tip.selectCurrency")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigCurrencySelections), ({ label, value }, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              label: label,
                              key: index,
                              value: value
                            }, null, 8, _hoisted_14))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_unref(Field), {
                        name: "currencyId",
                        class: "form-select form-select-solid",
                        modelValue: updateForm.value.toCurrencyId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updateForm.value.toCurrencyId) = $event)),
                        modelModifiers: { number: true },
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t("tip.selectCurrency")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigCurrencySelections), ({ label, value }, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              label: label,
                              key: index,
                              value: value
                            }, null, 8, _hoisted_19))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_unref(Field), {
                      type: "text",
                      class: "form-control form-control-solid",
                      name: "fromCurrencyName",
                      modelValue: updateForm.value.fromCurrencyName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((updateForm.value.fromCurrencyName) = $event)),
                      disabled: isUpdate.value
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_unref(Field), {
                      type: "text",
                      class: "form-control form-control-solid",
                      name: "toCurrencyName",
                      modelValue: updateForm.value.toCurrencyName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((updateForm.value.toCurrencyName) = $event)),
                      disabled: isUpdate.value
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  name: "name",
                  modelValue: updateForm.value.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((updateForm.value.name) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ErrorMessage), {
                  class: "fv-plugins-message-container invalid-feedback",
                  name: "name",
                  as: "div"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("tips.requiredField")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  name: "adjustRate",
                  modelValue: updateForm.value.adjustRate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((updateForm.value.adjustRate) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ErrorMessage), {
                  class: "fv-plugins-message-container invalid-feedback",
                  name: "adjustRate",
                  as: "div"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("tips.requiredField")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  name: "buyingRate",
                  modelValue: updateForm.value.buyingRate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((updateForm.value.buyingRate) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ErrorMessage), {
                  class: "fv-plugins-message-container invalid-feedback",
                  name: "buyingRate",
                  as: "div"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("tips.requiredField")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  name: "sellingRate",
                  modelValue: updateForm.value.sellingRate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((updateForm.value.sellingRate) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ErrorMessage), {
                  class: "fv-plugins-message-container invalid-feedback",
                  name: "sellingRate"
                })
              ])
            ]),
            (isUpdate.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _hoisted_36,
                  _hoisted_37,
                  _createElementVNode("table", _hoisted_38, [
                    _hoisted_39,
                    (isLoading.value)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_40, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_41, [
                              _createVNode(ScaleLoader)
                            ])
                          ])
                        ]))
                      : (!isLoading.value && dataHistory.value.length === 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_42, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.$t("tip.nodata")), 1)
                            ])
                          ]))
                        : (!isLoading.value && dataHistory.value.length != 0)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_44, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataHistory.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", null, _toDisplayString(updateForm.value.name), 1),
                                  _createElementVNode("td", null, _toDisplayString(item.changes.originalValues.BuyingRate), 1),
                                  _createElementVNode("td", null, _toDisplayString(item.changes.originalValues.SellingRate), 1),
                                  _createElementVNode("td", null, _toDisplayString(item.changes.originalValues.AdjustRate), 1),
                                  _createElementVNode("td", null, _toDisplayString(item.partyId), 1),
                                  _createElementVNode("td", null, _toDisplayString(item.changes.originalValues.UpdatedOn.split(" ")[0]), 1),
                                  _createElementVNode("td", null, _toDisplayString(item.changes.originalValues.UpdatedOn.split(" ")[1]), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                    (!isLoading.value && dataHistory.value.length > 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, " Scroll for More "))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-light-danger me-3",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (hide()))
                }, " Cancel ")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: updateExRate,
                  disabled: isLoading.value
                }, [
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                        _createTextVNode(_toDisplayString(_ctx.$t("action.waiting")) + " ", 1),
                        _hoisted_51
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_52, [
                        (isUpdate.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, "Update"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_54, "Create"))
                      ]))
                ], 8, _hoisted_49)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 512))
}
}

})